"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SETTLED = exports.SUCCEEDED = exports.STARTED = exports.QUEUED = exports.FAILED = void 0;
var FAILED = 'FAILED';
exports.FAILED = FAILED;
var QUEUED = 'QUEUED';
exports.QUEUED = QUEUED;
var STARTED = 'STARTED';
exports.STARTED = STARTED;
var SUCCEEDED = 'SUCCEEDED';
exports.SUCCEEDED = SUCCEEDED;
var SETTLED = 'SETTLED';
exports.SETTLED = SETTLED;